import React from "react";

/**
 * Prosper brand lockup — uses the official asset cropped from the
 * provided source image (P icon + PROSPER wordmark + tagline).
 */
export const ProsperLogo = ({ size = "lg", className = "", testId }) => {
  const height = size === "lg" ? "h-20 sm:h-24" : "h-10";
  return (
    <img
      data-testid={testId}
      src="/assets/prosper-logo.png"
      alt="Prosper — Turn your data into action"
      className={`${height} w-auto select-none ${className}`}
      draggable={false}
    />
  );
};

export default ProsperLogo;
